import { render, staticRenderFns } from "./Installations.vue?vue&type=template&id=2c9ecbea&scoped=true&"
import script from "./Installations.vue?vue&type=script&lang=ts&"
export * from "./Installations.vue?vue&type=script&lang=ts&"
import style0 from "./Installations.vue?vue&type=style&index=0&id=2c9ecbea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ecbea",
  null
  
)

export default component.exports